import { toast } from "react-toastify";
import * as Yup from "yup";
import FormDefault from "../../../components/Forms/FormDefault";
import { requestAuth } from "../../../components/services/RequestService";

const EditCompany = (props) => {
  const { companyInfo, onReload } = props;

  return (
    <div>
        <FormDefault
          tittle="Editar datos de la compañía"
          formClassName="grid grid-cols-2 gap-3"
          fields={[
            /* {
              label: "Id de compañia",
              name: "Num",
              placeholder: "Introduzca id de compañia (opcional)",
              type: "string",
              typeInput: "input",
            }, */
            {
              label: "Número de Identificación Tributaria (NIT)",
              name: "Nit",
              placeholder: "Introduzca su numero NIT",
              type: "number",
              typeInput: "input",
            },
            {
              label: "Razon social",
              name: "RazonSocial",
              placeholder: "Introdusca la Razon Social",
              type: "text",
              typeInput: "input",
            },
            {
              label: "Sigla",
              name: "Sigla",
              placeholder: "Ej: PLASTIFORTE",
              type: "text",
              typeInput: "input",
            },
            {
              label: "Correo electrónico",
              name: "Email",
              placeholder: "Introdusca el correo electrónico",
              type: "text",
              typeInput: "input",
            },
            {
              label: "Dirección",
              name: "Direccion",
              placeholder: "Dirección de la empresa",
              type: "text",
              typeInput: "input",
            },
            {
              label: "Ciudad",
              name: "Ciudad",
              placeholder: "Ciudad",
              type: "text",
              typeInput: "input",
            },
            {
              label: "Domicilio Legal (Representante)",
              name: "DomicilioLegal",
              placeholder: "Domicilio del representante legal",
              type: "text",
              typeInput: "input",
            },
            {
              label: "Representante Legal",
              name: "LegalRepresentativeName",
              placeholder: "Nombre completo",
              type: "text",
              typeInput: "input",
            },
            {
              label: "CI del Representante Legal",
              name: "LegalRepresentativeCI",
              placeholder: "Número de CI",
              type: "text",
              typeInput: "input",
            },
            {
              label: "CI Expedido en",
              name: "LegalRepresentativeCIEmision",
              placeholder: "Ej: Cochabamba",
              type: "text",
              typeInput: "input",
            },
            /* {
              label: "Testimonio N°",
              name: "Testimonio",
              placeholder: "N° de testimonio",
              type: "text",
              typeInput: "input",
            },
            {
              label: "FUNDEMPRESA / Matrícula",
              name: "Fundempresa",
              placeholder: "N° de matrícula",
              type: "text",
              typeInput: "input",
            }, */
          ]}
          initialValues={{
            Id: companyInfo?.id || "",
            Nit: companyInfo?.nit || "",
            RazonSocial: companyInfo?.razonSocial || "",
            Sigla: companyInfo?.sigla || "",
            Email: companyInfo?.email || "",
            Num: companyInfo?.num || "",
            Direccion: companyInfo?.direccion || "",
            Ciudad: companyInfo?.ciudad || "",
            DomicilioLegal: companyInfo?.domicilioLegal || "",
            LegalRepresentativeName: companyInfo?.legalRepresentativeName || "",
            LegalRepresentativeCI: companyInfo?.legalRepresentativeCI || "",
            LegalRepresentativeCIEmision: companyInfo?.legalRepresentativeCIEmision || "",
            testimonio: companyInfo?.testimonio || "",
            fundempresa: companyInfo?.fundempresa || "",
          }}
          validationSchema={Yup.object().shape({
            Nit: Yup.string().required("Este campo es obligatorio"),
            RazonSocial: Yup.string().required("Este campo es obligatorio"),
          })}
          onSubmit={async (values, resetForm) => {
            const companyId = values.Id || companyInfo?.id;
            await requestAuth("put", "company", values)
              .then(async () => {
                if (values.Testimonio || values.Fundempresa) {
                  const details = [];
                  if (values.Testimonio) details.push({ Label: "testimonio", Value: values.Testimonio });
                  if (values.Fundempresa) details.push({ Label: "fundempresa", Value: values.Fundempresa });
                  await Promise.all(
                    details.map((d) =>
                      requestAuth("post", "/company/detail", { ...d, CompanyId: companyId })
                    )
                  );
                }
                onReload();
                toast.success("Envio exitoso");
              })
              .catch(() => {
                toast.error("Se ha producido un error al enviar");
              });
          }}
          buttonName="Enviar"
        />
    </div>
  )
}

export default EditCompany